import { Injectable, inject } from "@angular/core";
import { CategoriesService } from "../shared";
import { ITranslateObject, TaxprepT1Card } from "../views-interfaces";

import { MultiSelectModel, Option } from "./filter-types";
import { CardDisplayService } from "../shared/card-display/card-display.service";

@Injectable({
    providedIn: "root",
})
export class CategoriesFilterGeneratorService {
    private readonly categoriesService = inject(CategoriesService);
    private readonly cardDisplayService = inject(CardDisplayService);

    constructor() {}

    async generateModel(selection: Option[]) {
        const categories = await this.categoriesService.getCategoriesList();
        const options = [
            {
                text: "FiltersSidebar.Options.Category.None",
                value: "none",
            } as Option,
        ].concat(
            categories.sort(this.categoriesService.sortByOrder).map((category) => {
                return {
                    text: category.Name,
                    value: category.Id,
                } as Option;
            }),
        );
        return {
            label: "FiltersSidebar.Labels.Category",
            allOptions: options,
            applicableOptions: options,
            selection: selection.filter((selected) => options.some((option) => option.value === selected.value)),
        } as MultiSelectModel;
    }

    getPrintDescription(
        label: string | ITranslateObject,
        selectedOptions: Option[],
    ): { label: string | ITranslateObject; values: (string | ITranslateObject)[] } | null {
        if (!selectedOptions || selectedOptions.length === 0) {
            return null;
        } else {
            return {
                label,
                values: selectedOptions.map((value) => {
                    return value.text;
                }),
            };
        }
    }

    generateFilter(selectedValues: string[]) {
        if (!selectedValues || selectedValues.length === 0) {
            return null;
        } else {
            return (card: TaxprepT1Card) => {
                const calculatedCategory = this.cardDisplayService.calculateCategoryForCard(card);
                const categoryId = calculatedCategory?.Id ?? "none";

                return selectedValues.includes(categoryId);
            };
        }
    }
}
